import React, { Component } from "react";
import {
  aggregateSum,
  aggregateAverage,
  aggregateMinimum,
  aggregateMaximum,
} from "../helpers/groupedRowAggregates";

import { AiFillCaretDown } from "react-icons/ai";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Fade from "@material-ui/core/Fade";
import COLORS from "scss/colors.module.scss";
import { formatDate, formatTime } from "../helpers/dateFormatter";

class FullWidthGroupedCellRenderer extends Component {
  constructor(props) {
    super(props);
    var availableAggregateColumns = [];

    props.node.columnController.columnDefs.map((column) => {
      if (
        (column.cellRendererParams.columnTypeId === "5" ||
          column.cellRendererParams.columnTypeId === "22" ||
           column.cellRendererParams.columnTypeId === "17")
        && column.headerName !== "Created By"
      ) {
        availableAggregateColumns.push({
          headerName: column.headerName,
          field: column.field,
          aggregate: "Sum",
          column_type_id: column.cellRendererParams.columnTypeId,
        });
        return 0;
      }
    });
    this.state = {
      availableAggregateColumns: availableAggregateColumns,
      bgColors: COLORS.GROUPED_AGGREGATE_BACKGROUNDS.split(","),
      aggregates: ["Sum", "Average", "Minimum", "Maximum"],
      popupVisible: false,
      indexOfAggregate: "",
      anchorEl: null,
      groupRowsCount: this.getGroupCount(),
    };
  }

  getListItem(name, callback) {
    return (
      <div className="groupAggregateOption" onClick={callback}>
        <div className="groupAggregateOptionName">{name}</div>
      </div>
    );
  }

  getAggregateValue = (column) => {
    var leafNodes = this.props.node.allLeafChildren;
    var field = column.field;
    let isPercentage = column.column_type_id == 22;
    var result = "";
    if (column.aggregate === "Sum") result = aggregateSum(leafNodes, field, isPercentage);
    else if (column.aggregate === "Average")
      result = aggregateAverage(leafNodes, field, isPercentage);
    else if (column.aggregate === "Minimum")
      result = aggregateMinimum(leafNodes, field, isPercentage);
    else if (column.aggregate === "Maximum")
      result = aggregateMaximum(leafNodes, field, isPercentage);
    return result;
  };

  setAggregate = (aggregate) => {
    var availableAggregateColumns = this.state.availableAggregateColumns;
    availableAggregateColumns[
      this.state.indexOfAggregate
    ].aggregate = aggregate;
    this.setState({
      popupVisible: false,
      availableAggregateColumns: availableAggregateColumns,
      indexOfAggregate: "",
      anchorEl: null,
    });
  };

  handleFilterChange = () => {
    this.setState({ groupRowsCount: this.getGroupCount() });
  }

  componentWillMount = () => {
    this.props.api.addEventListener("filterChanged", this.handleFilterChange)
  }

  componentWillUnmount = () => {
    this.props.api.removeEventListener("filterChanged", this.handleFilterChange)
  }

  getGroupCount = (node = this.props.node) => {
    if (!node.group) {
      return 0;
    }

    if (!node.childrenAfterFilter[0]?.group) {
      return node.allChildrenCount - 1;
    }

    return node.childrenAfterFilter.reduce((acc, cur) => acc + this.getGroupCount(cur), 0);
  }

  getGroupName = () => {
    let value = this.props?.node?.key;
    const dataIndex = this.props.node.field;
    const column = this.props.api.columnController.columnDefs.find((colDef) => colDef.field == dataIndex);
    const { columnTypeId, columnOptions } = column.cellRendererParams;
    if (columnTypeId === "22") {
      let decimals = columnOptions.decimals ? columnOptions.decimals : 2;
      value = Number(value * 100).toFixed(decimals - 2) + " %";
    } else if (columnTypeId === "10") {
      if (columnOptions.column_type == "percentage") {
        let decimals =
          String(value).length > 0 && String(value).indexOf(".") > -1
            ? String(value).split(".")[1].length
            : 2;
        value = (Number(value) * 100).toFixed(decimals - 2) + " %";
      }
    }
    return value;

    // if (columnTypeId == 4 || columnTypeId == "16") {
    //   return formatDate(value, "YYYY-MM-DD", columnOptions["format"]) + " " + formatTime(value, columnTypeId);
    // }
  };

  render() {
    return (
      <div className="d-flex">
        <span className="groupTitle"> {this.getGroupName()}</span>
        {this.state.availableAggregateColumns.map((column, index) => (
          <span
            key={index}
            className="aggregateContainer"
            style={{ backgroundColor: this.state.bgColors[index % 5] }}
          >
            {column.headerName}
            <div
              className="aggregate"
              onClick={(event) => {
                this.props.node.expanded = !this.props.node.expanded;
                this.setState({
                  popupVisible: true,
                  indexOfAggregate: index,
                  anchorEl: event.target,
                });
                document.addEventListener("mousedown", this.handleClickOutside);
              }}
            >
              {column.aggregate}
              <div className="downArrowAggregate">
                <AiFillCaretDown />
              </div>
            </div>
            &nbsp;:&nbsp;{this.getAggregateValue(column)}{column.column_type_id == 22 && " %"}
          </span>
        ))}
        <Menu
          id="fade-menu"
          anchorEl={this.state.anchorEl}
          keepMounted
          open={this.state.popupVisible}
          onClose={() => {
            this.setState({
              popupVisible: false,
              indexOfAggregate: "",
              anchorEl: null,
            });
          }}
          TransitionComponent={Fade}
        >
          {this.state.aggregates.map((aggregate, index) => (
            <MenuItem
              key={index}
              onClick={() => {
                this.setAggregate(aggregate);
              }}
            >
              {aggregate}
            </MenuItem>
          ))}
        </Menu>
        <div style={{
          display: "flex",
          alignItems: "center",
          padding: 5,
        }}>({
            this.state.groupRowsCount
          })</div>
      </div>
    );
  }
}

export default FullWidthGroupedCellRenderer;